import { render, staticRenderFns } from "./GoodsUse.vue?vue&type=template&id=51e84fbe&"
import script from "./GoodsUse.vue?vue&type=script&lang=js&"
export * from "./GoodsUse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports